import * as React from "react";
import * as PopoverPrimitive from "@radix-ui/react-popover";

import { cn } from "@/lib/utils";

const Root = PopoverPrimitive.Root;

const Trigger = PopoverPrimitive.Trigger;

const Portal = ({
  children,
  ...props
}: React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Portal>) => (
  <PopoverPrimitive.Portal {...props}>{children}</PopoverPrimitive.Portal>
);

const Content = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content>
>(({ className, sideOffset = 4, ...props }, ref) => (
  <PopoverPrimitive.Content
    ref={ref}
    sideOffset={sideOffset}
    className={cn(
      "z-50 w-auto rounded-md border border-secondary-300 bg-white-primary p-2 shadow-md",
      className,
    )}
    {...props}
  />
));
Content.displayName = PopoverPrimitive.Content.displayName;

const Arrow = React.forwardRef<
  React.ElementRef<typeof PopoverPrimitive.Arrow>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Arrow>
>(({ className, ...props }, ref) => (
  <PopoverPrimitive.Arrow ref={ref} className={cn(className)} {...props} />
));
Arrow.displayName = PopoverPrimitive.Arrow.displayName;

export { Root, Trigger, Portal, Content, Arrow };
